import axios from 'axios';
import router from '../router';
//import Vue from "vue/types/vue";
import qs from 'qs'
let base = ''

axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('carbon_emission_token');
    if (token != null && token.length > 0) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    if (response.data.code == 400 && -1 === response.config.url.indexOf('/login')) {
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
      })
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          sessionStorage.removeItem('user');
          localStorage.removeItem('carbon_emission_token');
        // router.replace({
        //     path: '/login',
        //     query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
        // })
      }
    }
    return Promise.reject(error.response.data)
  }
);

export const requestLogin = params => { return axios.post(`${base}/api/login/auth`, params).then(res => res.data); };
export const requestRegister = params => { return axios.post(`${base}/api/login/register`, params).then(res => res.data); };
//检索
export const getAgencyList = params => { return axios.get(`${base}/api/agency/list`, { params: params }); };
export const getAreaList = params => { return axios.get(`${base}/api/area/list`, { params: params }); };
export const getIndustryList = params => { return axios.get(`${base}/api/industrynew/list`, { params: params }); };
//政策数据浏览
export const getPolicyList = params => { return axios.get(`${base}/api/policy/list`, { params: params }); };
export const getPolicySearch = params => { return axios.get(`${base}/api/policy/search`, { params: params }); };
export const getPolicy = params => { return axios.get(`${base}/api/policy/detail`, { params: params }); };
export const getNavigate = params => { return axios.get(`${base}/api/policy/navigate`, { params: params }); };
//分析报告浏览
export const getReportList = params => { return axios.get(`${base}/api/report/list`, { params: params }); };
export const getReport = params => { return axios.get(`${base}/api/report/detail`, { params: params }); };
// 意见反馈
export const addOpinion = params => { return axios.post(`${base}/api/feedback`, params).then(res => res.data) };
// 案例
export const getCaseList = params => { return axios.get(`${base}/api/case/list`, { params: params }); };
export const getCase = params => { return axios.get(`${base}/api/case/detail`, { params: params }); };